import { render, staticRenderFns } from "./MoveHousePage.vue?vue&type=template&id=9a1c473c&scoped=true&"
import script from "./MoveHousePage.vue?vue&type=script&lang=js&"
export * from "./MoveHousePage.vue?vue&type=script&lang=js&"
import style0 from "./MoveHousePage.vue?vue&type=style&index=0&id=9a1c473c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1c473c",
  null
  
)

export default component.exports